<template>
  <div class="profile-dropdown-wrapper">
    <VaDropdown v-model="isShown" :offset="[9, 0]" class="profile-dropdown" stick-to-edges>
      <template #anchor>
        <VaButton preset="secondary" color="textPrimary">
          <span class="profile-dropdown__anchor min-w-max">
            <slot />
            <VaAvatar :size="32" color="primary">
              {{ initials }}
            </VaAvatar>
          </span>
        </VaButton>
      </template>
      <VaDropdownContent
        class="profile-dropdown__content md:w-60 px-0 py-4 w-full"
        :style="{ '--hover-color': hoverColor }"
      >
        <VaList>
          <header class="uppercase text-[var(--va-secondary)] opacity-80 font-bold text-xs px-4 mb-1 truncate">
            {{ auth.admin?.email }}
          </header>
          <VaListItem class="menu-item px-4 text-base cursor-pointer h-8" @click="onLogout">
            <VaIcon name="mso-logout" class="pr-1" color="secondary" />
            Выйти
          </VaListItem>
        </VaList>
      </VaDropdownContent>
    </VaDropdown>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useColors } from 'vuestic-ui'
import { useAuthStore } from '../../../../stores/auth'

const { colors, setHSLAColor } = useColors()
const hoverColor = computed(() => setHSLAColor(colors.focus, { a: 0.1 }))

const auth = useAuthStore()
const router = useRouter()

const isShown = ref(false)

const initials = computed(() => (auth.admin?.email?.[0] || 'A').toUpperCase())

const onLogout = async () => {
  isShown.value = false
  await auth.logout()
  router.push({ name: 'login' })
}
</script>

<style lang="scss">
.profile-dropdown {
  cursor: pointer;

  &__content {
    .menu-item:hover {
      background: var(--hover-color);
    }
  }

  &__anchor {
    display: inline-block;
  }
}
</style>
